import {
  Text,
  VStack,
  HStack,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Box,
} from '@chakra-ui/react';

import Card from 'components/card/Card';
import { useAppSelector, useAppDispatch } from 'hooks';
import {
  setPaperCopiesRequired,
  setPaperCopyReason,
  PaperCopyReason,
  useLegacyAutoFormLocked,
} from 'reducers/legacyAutoFormReducer';

const PaperCopySection = () => {
  const dispatch = useAppDispatch();
  const isLocked = useLegacyAutoFormLocked();

  const paperCopiesRequired = useAppSelector(
    (state) => state.legacyAutoForm.data.additional_info.paper_copies_required,
  );
  const paperCopyReason = useAppSelector(
    (state) => state.legacyAutoForm.data.additional_info.paper_copy_reason,
  );

  const handlePaperCopiesRequiredChange = (value: string) => {
    dispatch(setPaperCopiesRequired(value === 'yes'));
  };

  const handleReasonChange = (value: string) => {
    dispatch(setPaperCopyReason(value as PaperCopyReason));
  };

  return (
    <Card mb="20px" id="sectionPaperCopy">
      <Text fontWeight="bold" fontSize="2xl" mb="20px">
        Paper Copy Requirement
      </Text>

      <VStack spacing={4} align="stretch">
        <FormControl>
          <FormLabel ml="0">Paper Copies Required?</FormLabel>
          <RadioGroup
            value={paperCopiesRequired ? 'yes' : 'no'}
            onChange={handlePaperCopiesRequiredChange}
            isDisabled={isLocked}
          >
            <HStack spacing={8}>
              <Radio value="yes">Yes</Radio>
              <Radio value="no">No</Radio>
            </HStack>
          </RadioGroup>
        </FormControl>

        {paperCopiesRequired && (
          <Box p={4} borderWidth="1px" borderRadius="md" borderColor="gray.200">
            <FormControl>
              <FormLabel ml="0">Reason (select one)</FormLabel>
              <RadioGroup
                value={paperCopyReason || ''}
                onChange={handleReasonChange}
                isDisabled={isLocked}
              >
                <VStack align="start" spacing={3}>
                  <Radio value="vulnerable_customer">Vulnerable Customer</Radio>
                  <Radio value="no_email_internet">
                    No Email or Internet Access
                  </Radio>
                  <Radio value="customer_requests_paper">
                    Customer Requests Paper Only
                  </Radio>
                </VStack>
              </RadioGroup>
            </FormControl>
          </Box>
        )}
      </VStack>
    </Card>
  );
};

export default PaperCopySection;
